export enum QualificationStatusValues {
  NotMarked = "NOT_MARKED",
  Qualified = "QUALIFIED",
  Unqualified = "UNQUALIFIED",
  NotApplied = "NOT_APPLIED",
}

export type QualificationStatus = QualificationStatusValues;
